// extracted by mini-css-extract-plugin
export default {"assignButton":"AssignPreconfigButton_assignButton__d8bnW"};